// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__3LSaF","choiceBoxes":"toolbarselects_choiceBoxes__3PX4c","simpleField":"toolbarselects_simpleField__2xQJx"};